import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import AccountCTA from "./AccountCTA";

const ConnectedReceiptFundraisingAccount = ({ controlId }) => {
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        isFundraisingParticipant,
        global: { hasActiveGlobalAccount },
        contact: { firstName },
    } = registrationAccount;

    const {
        ENUMS: { DefaultView },
    } = constants;
    // Get CMS data for the component
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );
    const {
        options: { activateAccount, startFundraising },
    } = control;
    // Toggle the sectionHeading and additionalAccount text based on what needs
    // to be displayed
    const sectionHeading = hasActiveGlobalAccount
        ? startFundraising.sectionHeading
        : activateAccount.sectionHeading;
    const additionalText = hasActiveGlobalAccount
        ? startFundraising.additionalText
        : activateAccount.additionalText;
    // Set up the function to be called if hasGlobalAccount is false and
    // activateAccount.sectionHeading is used for the Section Heading
    const renderSectionHeading = sectionHeading.includes("%FirstName%")
        ? (_sectionHeading) => (
              <h2>
                  {_sectionHeading.split("%FirstName%")[0]}
                  {firstName}
                  {_sectionHeading.split("%FirstName%")[1]}
              </h2>
          )
        : undefined;

    // Inject the component with data
    const accountCTAProps = {
        isFundraisingParticipant,
        additionalText,
        sectionHeading,
        renderSectionHeading,
    };

    return <AccountCTA {...accountCTAProps} />;
};

ConnectedReceiptFundraisingAccount.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptFundraisingAccount;
